const isAllowDebug = () => {
  if (window && window.location) {
    const hostname = window.location.hostname || '';
    return hostname === 'localhost' || hostname.includes('windsorsolutions.biz');
  }
  return false;
};

export default isAllowDebug;
